import React, { memo, useMemo } from 'react';
import { Tabs as UiKitTabs } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { withAnalyticsTabs } from "../../hocs";
import { useTabs } from "./useTabs";
import { TabContent } from "./components/TabContent";
import { TextInfo } from "./components/TextInfo";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var _Tabs = function _Tabs(_ref) {
  var _tabs$index, _tabs$index$content, _tabs$index2, _tabs$index2$content;
  var headerBarConfig = _ref.headerBarConfig,
    variant = _ref.variant,
    isScrollable = _ref.isScrollable,
    tabs = _ref.tabs,
    onTabChange = _ref.onTabChange;
  var uiKitTabs = useMemo(function () {
    return (tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab, index) {
      return {
        id: String(index),
        title: tab.title
      };
    })) || [];
  }, [tabs]);
  var _useTabs = useTabs(uiKitTabs, onTabChange),
    index = _useTabs.index,
    selectedTab = _useTabs.selectedTab,
    onChange = _useTabs.onChange;
  var tabContentType = tabs === null || tabs === void 0 ? void 0 : (_tabs$index = tabs[index]) === null || _tabs$index === void 0 ? void 0 : (_tabs$index$content = _tabs$index.content) === null || _tabs$index$content === void 0 ? void 0 : _tabs$index$content.type;
  var tabContentData = tabs === null || tabs === void 0 ? void 0 : (_tabs$index2 = tabs[index]) === null || _tabs$index2 === void 0 ? void 0 : (_tabs$index2$content = _tabs$index2.content) === null || _tabs$index2$content === void 0 ? void 0 : _tabs$index2$content.data;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('landing-tabs'),
    "data-t-id": "components-Tabs"
  }, /*#__PURE__*/React.createElement(TextInfo, {
    headerText: headerBarConfig === null || headerBarConfig === void 0 ? void 0 : headerBarConfig.headerText,
    subtitleText: headerBarConfig === null || headerBarConfig === void 0 ? void 0 : headerBarConfig.subtitleText
  }), /*#__PURE__*/React.createElement(UiKitTabs, {
    isScrollable: isScrollable,
    onChange: onChange,
    selectedTab: selectedTab,
    tabs: uiKitTabs,
    variant: variant
  }), /*#__PURE__*/React.createElement(TabContent, {
    data: tabContentData,
    type: tabContentType
  }));
};
export var Tabs = withAnalyticsTabs( /*#__PURE__*/memo(_Tabs));